import React from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DESKTOP_CONTENT_WIDTH } from '../../../../constants/Layout';

import MainContent from '../../../common/MainContent';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '0 auto',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      marginRight: '10%',
    },
    width: DESKTOP_CONTENT_WIDTH,
    marginTop: 44,
    height: 'auto',
  },
}));

const Content = () => {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={classes.root}>
      <MainContent />
    </Paper>
  );
};

export default Content;
